import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useParams, useLocation } from 'react-router-dom'

import { useShallowEqualSelector } from 'custom-hooks'
import { dateRangeConst } from 'constants/dateRangeConstants'
import moment from 'utils/momentInstanse'
import ConsumptionChart from './components/ConsumptionChart'
import LastUpdateBlock from 'components/LastUpdateBlock/LastUpdateBlock'
import PerfomanceBlock from './components/PerfomanceBlock'
import FacilityCurrentInfoBlock from './components/FacilityCurrentInfoBlock'
import DateRangeFilterSection from './components/DateRangeFilterSection'
import TopTotalInfo from 'components/TopTotalInfo/TopTotalInfo'
import Title from 'components/CommonUI/Title/Title'
import {
  getCurrentFacilityData,
  setFacilityId,
  getLastUpdateDateSelector,
  getIsFetchingChartAreaDataSelector,
  selectConsumptionFacility,
  getFacilityDateRangeSelector,
  setSelectedDateRangeRedirect,
  setDefaultDateSelect,
} from 'redux/reducers/facility'
import HeatMapSection from './components/HeatMapSection'

const Facility = () => {
  const { facilityId } = useParams()
  const { state } = useLocation()
  const dispatch = useDispatch()

  const selectedDateRange = useShallowEqualSelector(
    getFacilityDateRangeSelector
  )

  const totalDataConsumption = useShallowEqualSelector(
    selectConsumptionFacility
  )

  const isFetchingChartArea = useShallowEqualSelector(
    getIsFetchingChartAreaDataSelector
  )

  const lastUpdateDate = useShallowEqualSelector(getLastUpdateDateSelector)

  useEffect(() => {
    dispatch(
      setDefaultDateSelect({
        id: dateRangeConst.today.id,
        label: dateRangeConst.today.label,
        value: {
          start_timestmp: moment().startOf('day').utc().unix(),
          end_timestmp: moment().endOf('day').utc().unix(),
        },
      })
    )
  }, [dispatch])

  useEffect(() => {
    if (state?.selectedDateRangeRedirect) {
      dispatch(setSelectedDateRangeRedirect(state?.selectedDateRangeRedirect))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch])

  useEffect(() => {
    if (facilityId) {
      dispatch(setFacilityId(facilityId))
      dispatch(getCurrentFacilityData())
    }
    return () => {
      dispatch(setFacilityId(null))
    }
  }, [dispatch, facilityId])

  return (
    <div className="facility_container">
      <div className="content-holder">
        <div className="main_block">
          <Title title="Facility dashboard" />
          <DateRangeFilterSection selectedDateRange={selectedDateRange} />
        </div>
        <div className="update_block">
          <LastUpdateBlock date={lastUpdateDate} />
        </div>
      </div>
      <div className="content-wrapper">
        <div className="main-content">
          <TopTotalInfo
            {...totalDataConsumption}
            className="top_total_info_container"
            isFetching={isFetchingChartArea}
          />
          <ConsumptionChart
            isFetching={isFetchingChartArea}
            facilityId={facilityId}
            selectedDateRange={selectedDateRange}
          />
          <HeatMapSection />
        </div>
        <div className="aside-content">
          <FacilityCurrentInfoBlock id={facilityId} />
          <PerfomanceBlock id={facilityId} />
        </div>
      </div>
    </div>
  )
}

export default Facility
